class KlaviyoForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    if (typeof KlaviyoSubscribe === "undefined") return;

    this.preference = null;
    this.preferenceInputs = this.querySelectorAll("[data-preference-selector]");

    this.submitLabel = "";
    this.loadingTimer = null;

    this.initFunction();
  }

  initFunction() {
    this.initKlaviyoForm();
    this.form.email.addEventListener("keypress", this.removeError.bind(this));
    this.form.addEventListener("submit", this.handleErrorValidation.bind(this));
    window.addEventListener("pageshow", this.stopLoading.bind(this));

    this.preferenceInputs.forEach((input) => {
      input.addEventListener("change", (event) => {
        this.preference = event.target.value;

        KlaviyoSubscribe.attachToForms(this.form, {
          hide_form_on_success: true,
          success: () => this.handleSuccess(),
          extra_properties: {
            $source: "Shopify Form",
            $method_type: "Custom Klaviyo Form",
            $consent_version: "",
          },
        });
      });
    });
  }

  initKlaviyoForm() {
    KlaviyoSubscribe.attachToForms(this.form, {
      hide_form_on_success: true,
      success: () => this.handleSuccess(),
      extra_properties: {
        $source: "Shopify Form",
        $method_type: "Custom Klaviyo Form",
        $consent_version: "",
      },
    });
  }

  getSubmitButton() {
    return this.form ? this.form.querySelector('[type="submit"]') : null;
  }

  startLoading() {
    const button = this.getSubmitButton();
    if (!button || button.disabled) return;

    this.submitLabel = button.textContent;
    const loadingLabel = button.dataset.loadingLabel;

    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    if (loadingLabel) {
      button.textContent = loadingLabel;
    }

    clearTimeout(this.loadingTimer);
    this.loadingTimer = setTimeout(this.stopLoading.bind(this), 15000);
  }

  stopLoading() {
    const button = this.getSubmitButton();
    if (!button) return;

    clearTimeout(this.loadingTimer);
    button.disabled = false;
    button.removeAttribute("aria-busy");

    if (this.submitLabel) {
      button.textContent = this.submitLabel;
    }
  }

  handleSuccess() {
    const redirect = this.dataset.redirect;
    const flag = this.dataset.flag;

    if (redirect) {
      if (flag) {
        try {
          window.localStorage.setItem(flag, Date.now().toString());
        } catch (error) {
          console.log(`unable to store gate flag`, error);
        }
      }

      clearTimeout(this.loadingTimer);
      window.location.assign(redirect);
      return;
    }

    this.stopLoading();
    this.classList.add("success");

    setTimeout(() => {
      this.classList.remove("success");
    }, 5000);
  }

  handleErrorValidation(event) {
    const email = this.form.email.value;
    const emailInput = this.form.email;
    const emailError = this.form.querySelector(".input-label__error");
    if (this.validateEmail(email)) {
      emailInput.classList.remove("error");
      emailInput.setAttribute("aria-invalid", "false");
      this.startLoading();
    } else {
      event.preventDefault();
      this.stopLoading();
      if (emailError.querySelector(".message")) {
        emailError.querySelector(".message").remove();
      }

      const errorMessage =
        this.form.email.dataset.errorMessage ||
        "Please enter a valid email address";

      emailInput.classList.add("error");
      emailInput.setAttribute("aria-invalid", "true");
      emailError.textContent = errorMessage;
      emailInput.focus();
    }
  }

  removeError() {
    this.form.email.classList.remove("error");
    this.form.email.setAttribute("aria-invalid", "false");
  }

  validateEmail(email) {
    if (new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}").test(email)) {
      return true;
    }

    return false;
  }
}

if (!customElements.get("klaviyo-form")) {
  customElements.define("klaviyo-form", KlaviyoForm);
}
